import { createAction } from '@reduxjs/toolkit';
import { REPLY_MESSAGE } from './componentsActions';
export const replyMessage = createAction(REPLY_MESSAGE);
